import {
  type TourStepTooltipConfig,
  tooltipDefaultConfig,
} from '@carboncopyco/types';

export const getNewTooltipConfig = ({
  config,
}: {
  config: TourStepTooltipConfig;
}): TourStepTooltipConfig => {
  return {
    ...tooltipDefaultConfig,
    ...config,
    balloon: {
      ...config.balloon,
    },
    buttons: {
      ...config.buttons,
      nextButton: {
        ...config.buttons.nextButton,
        action: tooltipDefaultConfig.buttons.nextButton?.action,
        label: tooltipDefaultConfig.buttons.nextButton?.label,
      },
      previousButton: {
        ...config.buttons?.previousButton,
        action: tooltipDefaultConfig.buttons.previousButton.action,
        label: tooltipDefaultConfig.buttons.previousButton.label,
      },
      lastStepButton: {
        ...config.buttons?.lastStepButton,
        action: tooltipDefaultConfig.buttons.lastStepButton.action,
        label: tooltipDefaultConfig.buttons.lastStepButton.label,
      },
    },
    navigationOptions: tooltipDefaultConfig.navigationOptions,
  };
};
